// import React, { useEffect, useState } from "react";
// import io from "socket.io-client";
// import phoneGif from "../assets/img/phone.gif";

// const FooterScript = ({ userId, userType, notifySocketUrl, subsEditLink }) => {
//   const [notifications, setNotifications] = useState([]);

//   useEffect(() => {
//     if (!userId || !notifySocketUrl) return;

//     const socket = io(notifySocketUrl, { transports: ["websocket"], reconnection: true });

//     socket.on("connect", () => {
//       socket.emit("connected", userId);
//     });

//     socket.on("showPopUp", (data) => {
//       if (String(data.userid) === String(userId)) {
//         setNotifications((prev) => [
//           ...prev,
//           {
//             id: Date.now(),
//             title: "Incoming Call...",
//             content: `From - ${data.name}`,
//             link: `${subsEditLink}${data.subid}`,
//             img: phoneGif,
//           },
//         ]);
//       }
//     });

//     let notifySocket;
//     const allowedTypes = ["1", "3", "4", "5", "18", "19"];
//     if (allowedTypes.includes(String(userType))) {
//       notifySocket = io(notifySocketUrl, { transports: ["websocket"], reconnection: true });

//       notifySocket.on("getNotify", (data) => {
//         setNotifications((prev) => [
//           ...prev,
//           {
//             id: Date.now(),
//             title: data.title,
//             content: data.msg,
//             link: null,
//           },
//         ]);
//       });
//     }

//     return () => {
//       socket.disconnect();
//       if (notifySocket) notifySocket.disconnect();
//     };
//   }, [userId, userType, notifySocketUrl, subsEditLink]);

//   useEffect(() => {
//     if (!notifications.length) return;
//     const timer = setTimeout(() => {
//       setNotifications((prev) => prev.slice(1));
//     }, 1500000000);
//     return () => clearTimeout(timer);
//   }, [notifications]);

//   const handleClose = (id) => {
//     setNotifications((prev) => prev.filter((n) => n.id !== id));
//   };

//   const styles = {
//     container: {
//       position: "fixed",
//       top: "10px",
//       right: "10px",
//       zIndex: 9999,
//       maxWidth: "400px",
//     },
//     notification: {
//       background: "#ffffff",
//       borderRadius: "8px",
//       boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
//       marginBottom: "10px",
//       overflow: "hidden",
//       animation: "slideIn 0.3s ease-out",
//       border: "1px solid #e5e5e5",
//     },
//     header: {
//       background: "linear-gradient(135deg, #1e90ff 0%, #0066cc 100%)",
//       padding: "12px 15px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//     },
//     headerLeft: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     },
//     icon: {
//       width: "30px",
//       height: "30px",
//       background: "#ffffff",
//       borderRadius: "6px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "18px",
//     },
//     title: {
//       color: "#ffffff",
//       fontWeight: "600",
//       fontSize: "14px",
//       margin: 0,
//       letterSpacing: "0.3px",
//     },
//     closeButton: {
//       background: "transparent",
//       border: "none",
//       color: "#ffffff",
//       fontSize: "18px",
//       cursor: "pointer",
//       padding: "0 5px",
//       opacity: 0.8,
//       transition: "opacity 0.2s",
//     },
//     closeButtonHover: {
//       opacity: 1,
//     },
//     content: {
//       padding: "15px",
//       color: "#333333",
//       fontSize: "13px",
//       lineHeight: "1.5",
//     },
//     contentWithLink: {
//       padding: "15px",
//       color: "#333333",
//       fontSize: "13px",
//       lineHeight: "1.5",
//       display: "block",
//       textDecoration: "none",
//       transition: "background 0.2s",
//     },
//     contentText: {
//       margin: 0,
//       color: "#666666",
//     },
//     link: {
//       color: "#1e90ff",
//       textDecoration: "none",
//       fontWeight: "500",
//     },
//   };

//   const keyframes = `
//     @keyframes slideIn {
//       from {
//         transform: translateX(400px);
//         opacity: 0;
//       }
//       to {
//         transform: translateX(0);
//         opacity: 1;
//       }
//     }
//   `;

//   return (
//     <>
//       <style>{keyframes}</style>
//       <div style={styles.container}>
//         {notifications.map((n) => (
//           <div key={n.id} style={styles.notification}>
//             <div style={styles.header}>
//               <div style={styles.headerLeft}>
//                 <div style={styles.icon}>
//                   {n.img ? (
//                     <img src={n.img} alt="" style={{ width: "20px", height: "20px" }} />
//                   ) : (
//                     "🔔"
//                   )}
//                 </div>
//                 <h3 style={styles.title}>{n.title}</h3>
//               </div>
//               <button
//                 style={styles.closeButton}
//                 onClick={() => handleClose(n.id)}
//                 onMouseEnter={(e) => (e.target.style.opacity = "1")}
//                 onMouseLeave={(e) => (e.target.style.opacity = "0.8")}
//               >
//                 Close
//               </button>
//             </div>
//             {n.link ? (
//               <a
//                 href={n.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 style={styles.contentWithLink}
//                 onMouseEnter={(e) => (e.target.style.background = "#f8f9fa")}
//                 onMouseLeave={(e) => (e.target.style.background = "transparent")}
//               >
//                 <p style={styles.contentText}>{n.content}</p>
//               </a>
//             ) : (
//               <div style={styles.content}>
//                 <p style={styles.contentText}>{n.content}</p>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </>
//   );
// };

// export default FooterScript;

import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import "bootstrap-icons/font/bootstrap-icons.css"; // make sure bootstrap-icons are installed

const FooterScript = ({ userId, userType, notifySocketUrl, subsEditLink }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!userId || !notifySocketUrl) return;

    const socket = io(notifySocketUrl, { transports: ["websocket"], reconnection: true });

    socket.on("connect", () => {
      socket.emit("connected", userId);
    });

    socket.on("showPopUp", (data) => {
      if (String(data.userid) === String(userId)) {
        setNotifications((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "Incoming Call...",
            content: `From - ${data.name}`,
            link: `${subsEditLink}${data.subid}`,
          },
        ]);
      }
    });

    let notifySocket;
    const allowedTypes = ["1", "3", "4", "5", "18", "19"];
    if (allowedTypes.includes(String(userType))) {
      notifySocket = io(notifySocketUrl, { transports: ["websocket"], reconnection: true });

      notifySocket.on("getNotify", (data) => {
        setNotifications((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: data.title || "New Notification",
            content: data.msg,
            link: data.link || null,
          },
        ]);
      });
    }

    return () => {
      socket.disconnect();
      if (notifySocket) notifySocket.disconnect();
    };
  }, [userId, userType, notifySocketUrl, subsEditLink]);

    useEffect(() => {
    if (!notifications.length) return;

    const timers = notifications.map((n) =>
      setTimeout(() => {
        setNotifications((prev) => prev.filter((item) => item.id !== n.id));
      }, 15000)
    );

    return () => timers.forEach((t) => clearTimeout(t));
  }, [notifications]);

  const handleClose = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const styles = {
    container: {
      position: "fixed",
      top: "10px",
      right: "10px",
      zIndex: 9999,
      maxWidth: "557px",
    },
    notification: {
      background: "rgb(239 239 239)",
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      marginBottom: "10px",
      overflow: "hidden",
      animation: "slideIn 0.3s ease-out",
      display: "flex",
      alignItems: "stretch",
    },
    iconSection: {
      // background: "linear-gradient(135deg, #4A90E2 0%, #357ABD 100%)",
      width: "65px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    bellIcon: {
      width: "36px",
      height: "36px",
      background: "#ffffff",
      borderRadius: "10%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "22px",
      background: "rgb(20 166 252)",
    },
    contentSection: {
      flex: 1,
      padding: "14px 16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    title: {
      fontWeight: "600",
      fontSize: "13px",
      color: "#1a1a1a",
      margin: "0 0 6px 0",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      lineHeight: 1.2,
    },
    message: {
      fontSize: "12.5px",
      color: "#555555",
      margin: 0,
      lineHeight: "1.5",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
    },
    closeButton: {
      background: "transparent",
      border: "none",
      color: "#888",
      cursor: "pointer",
      padding: "12px 16px",
      fontSize: "13px",
      alignSelf: "flex-start",
      fontWeight: "500",
      transition: "color 0.2s",
    },
    divider: {
      width: "1px",
      background: "#ccc",
      margin: "0 10px",
    },
  };

  const keyframes = `
    @keyframes slideIn {
      from {
        transform: translateX(450px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div style={styles.container}>
        {notifications.map((n) => (
          <div key={n.id} style={styles.notification}>
            {/* Blue icon section */}
            <div style={styles.iconSection}>
              <div style={styles.bellIcon}>
                <i className="bi bi-bell" style={{color:"white"}}></i>
              </div>
            </div>

            {/* Content section */}
            {n.link ? (
              <a
                href={n.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ ...styles.contentSection, textDecoration: "none" }}
              >
                <h3 style={styles.title}>{n.title}</h3>
                <p style={styles.message}>{n.content}</p>
              </a>
            ) : (
              <div style={styles.contentSection}>
                <h3 style={styles.title}>{n.title}</h3>
                <p style={styles.message}>{n.content}</p>
              </div>
            )}

            <div style={styles.divider}></div>

            {/* Close button */}
            <button
              onClick={() => handleClose(n.id)}
              onMouseEnter={(e) => (e.target.style.color = "#333")}
              onMouseLeave={(e) => (e.target.style.color = "#888")}
              style={styles.closeButton}
              className= "my-auto"
            >
              Close
            </button>
          </div>
        ))}
      </div>
    </>
  );
};

export default FooterScript;
